import $api from "../http";

export const sendFormService = async (model, phone, note) => {
  return await $api.post("/mail/form", {
    model,
    phone,
    note,
  });
};
